module.exports = "<!--$Id$-->\r\n<div class=\"input-error col-md-12\">\r\n    {{messagem}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/paraEmpresas/mensagem/mensagem.component.html
// module id = 1170
// module chunks = 1